import ScrollX from "components/ScrollX";
import ReactTable from "components/statosfera/table/ReactTable";
import useAuth from "hooks/useAuth";
import PaginationData from "model/dto/PaginationData";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ClientDetailsViewModel from "../model/ClientDetailsViewModel";

export default({clientId}) => {
    const dispatcher = useDispatch();
    const context = useAuth();
    const [t, i18n] = useTranslation();
    const data = useSelector(state => ClientDetailsViewModel.loadFromStore(state));
    const model = new ClientDetailsViewModel(null, context.user);
    const [loaded, setLoaded] = useState(false);
    const [filter, setFilter] = useState(model.getFieldFilter(10, "sentAt"));
    useEffect(() => {
        if(data) {
          setLoaded(false);
          model.fetchClientCommunications(dispatcher, clientId, filter).unwrap().then(res => {
            setLoaded(true);
          });
        }
      }, [data, dispatcher, clientId, filter]);
    if(!data) {
        return "";
    }
    const columns = useMemo(
      () => [
        {
          Header: '#',
          accessor: 'id',
          disableSortBy: true
        },
        {
          Header: t('title'),
          accessor: 'title',
          disableSortBy: true
        },
        {
          Header: t('address'),
          accessor: 'address',
          disableSortBy: true
        },
        {
          Header: t('type'),
          accessor: 'type',
          disableSortBy: true
        },
        {
          Header: t('subtype'),
          accessor: 'subType',
          disableSortBy: true
        },
        {
          Header: t('status'),
          accessor: 'status',
          disableSortBy: true
        },
        {
          Header: t('result'),
          accessor: 'sendResult',
          disableSortBy: true
        },
        {
          Header: t('sent_at'),
          accessor: 'sentAt'
        }
      ]);
    const handlePageChange = (data) => {
      filter.page = data;
      setFilter(PaginationData.from(filter));
    }

    const handlePageSizeChange = (data) => {
      filter.limit = data;
      setFilter(PaginationData.from(filter));
    }

    const handleSort = (id, desc) => {
      let sameDir = (filter.order == "desc" && desc) || (filter.order == "asc" && !desc);
      if(filter.orderBy == id && sameDir) {
        return;
      }
      filter.orderBy = id;
      filter.order = (desc) ? "desc" : "asc";
      setFilter(PaginationData.from(filter));
    }

    const commData = useSelector(state => state.client.clientCommunications);
    if(!commData) {
      return "";
    }
    let items = [];
    commData?.data?.items.forEach(i => {
      items.push({
        id: i.id,
        title: model.dataOrEmpty(i.title),
        address: model.dataOrEmpty(i.address),
        type: i.type,
        subType: i.subType,
        status: i.status,
        sendResult: model.dataOrEmpty(i.sendResult),
        sentAt: model.formatShortDate(i.sentAt)
      });
    });
    const sortBy = { id: 'sentAt', desc: true };
    return(
      <>
        <ScrollX>
          <ReactTable
            columns={columns}
            data={items}
            page={filter.page}
            pageSize={filter.limit}
            sortBy={sortBy}
            search={''}
            rowCountTotal={commData?.data?.numOfItems} 
            getHeaderProps={(column) => column.getSortByToggleProps()}
            handlePageChange={handlePageChange} 
            handlePageSizeChange={handlePageSizeChange}
            handleSort={handleSort}
            handleSearch={null}
            topSpacing={0} />
        </ScrollX>
      </>
    );
}